module.exports = __webpack_public_path__ + "img/enjoy-safety.e5e83165.jpg";